<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">{{'Create New Measurement Point' | translate | async}}</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
    </div>
    <div class="ttmodal__header">

        <mat-radio-group aria-label="Select an option" color="warn" [(ngModel)]="TypeID">
          <mat-radio-button [value]="1" *ngIf="typeSelected==1">{{'Rope Shovel/Hydraulic Shovel' | translate | async}}</mat-radio-button>
          <mat-radio-button [value]="2" *ngIf="typeSelected==2">{{"URC" | translate | async}}</mat-radio-button>
        </mat-radio-group>
        <!-- <mat-radio-group name="type" id="MeasuremenType" [(ngModel)]="TypeID" aria-label="Select an option">
            <mat-radio-button (change)="changeType($event)" [value]="1">Rope Shovel/Hydraulic Shovel</mat-radio-button>
            <mat-radio-button (change)="changeType($event)" [value]="2">WSRE</mat-radio-button>
          </mat-radio-group> -->
    </div>
    <div class="ttmodal__body scroll">

        <div>

            <mat-radio-group  id="WsreInspectionType" color="warn" *ngIf="TypeID==2 && existingPoint == null" name="type" [(ngModel)]="WsreTypeID" aria-label="Select an option">
                <mat-radio-button (change)="changeWSREType($event)" [value]="1">{{"Idler" | translate | async}}</mat-radio-button>
                <mat-radio-button (change)="changeWSREType($event)" [value]="2">{{'Frame' | translate | async}}</mat-radio-button>
              </mat-radio-group>


              <div  class="input-container">
                <span class="input-desc-label">{{'Component Type' | translate | async}}
                   
                </span>
                <input [(ngModel)]="compType" type="text" placeholder="Component Type"  [disabled]="true"  >
            </div>

            <div  class="input-container">
                <span class="input-desc-label">{{'Component Name' | translate | async}}
                   
                </span>
                <input [(ngModel)]="compName" type="text" placeholder="Component Name"  [disabled]="true"  >
            </div>

              <div *ngIf="TypeID==2 && WsreTypeID==2" class="input-container">
                <span class="input-desc-label">{{'Select a Sub-Component' | translate | async}}
                    <span class="red-text">*</span>
                </span>
                 <div *ngIf="isLoading ==true" style="display: flex;flex-direction: column;align-items: center;
                  justify-content: center;align-self: center;">
                        <mat-spinner></mat-spinner>
                  </div>
                <select  *ngIf="isLoading ==false" class="select" [(ngModel)]="SelectedWSREMeasrementPointTypeID"  ngDefaultControl>
                    <option value=0 disabled selected>{{'Select a Sub-Component' | translate | async}}</option>
                    <option *ngFor="let tool of WSREMeasurmentPoints" [value]="tool.Id">{{tool.Name}}</option>
                </select>

                <div *ngIf="isLoading ==false" style="align-self: center;">
                    <a style="cursor: pointer;color: #000000;" (click)="SetupWSREMeasurementPoint()"
                        title="Add New Sub-Component">
                        <i class="material-icons button__icon" style="font-weight: bold;"> add</i></a>
                </div>

                
            </div>

            <div class="input-container">
                <span  class="input-desc-label">{{'Select Model' | translate | async}}
                    <span class="red-text">*</span>
                </span>
                <mat-select  id="select-model" class="select" placeholder="Select Model"  style="width: 55%;" [(ngModel)]="SelectedModel" 
                      ngDefaultControl>
                     <!-- // <mat-option value=0 >All Models</mat-option> -->
                    <mat-option [value]="model.Id" *ngFor="let model of CompartModels">
                        {{model.Name}}
                    </mat-option>
                </mat-select>
                
            </div>

            <!-- <div *ngIf="TypeID==2 && WsreTypeID==2" class="input-container">
                <span *ngIf="isLoading ==false && existingPoint == null" class="input-desc-label">Select Model
                    <span class="red-text">*</span>
                </span>
                <mat-select *ngIf="isLoading ==false && existingPoint == null" id="select-model" placeholder="Select Model"  style="width: 55%;" [(ngModel)]="SelectedModels" 
                      ngDefaultControl    multiple>
                      <mat-option value=0 >All Models</mat-option>
                    <mat-option [value]="model.Id" *ngFor="let model of CompartModels">
                        {{model.Name}}
                    </mat-option>
                </mat-select>
                
            </div> -->

            <div *ngIf="TypeID==1 || WsreTypeID==2 " class="input-container">
                <span class="input-desc-label">{{'Name' | translate | async}}
                    <span class="red-text">*</span>
                </span>
                <input [(ngModel)]="measurementPointName" type="text" placeholder="Measurement Point 1"  [formControl]="measurementNameControl" required ngDefaultControl >
            </div>
            
            <div *ngIf="TypeID==2 && WsreTypeID==1" class="input-container">
                <span class="input-desc-label">{{"Name" | translate | async}}
                    <span class="red-text">*</span>
                </span>
                 <div *ngIf="isLoading ==true" style="display: flex;flex-direction: column;align-items: center;
                  justify-content: center;align-self: center;">
                        <mat-spinner></mat-spinner>
                  </div>
                  <input [disabled]="true" *ngIf="isLoading ==false && existingPoint != null" [(ngModel)]="measurementPointName" type="text" placeholder="Measurement Point 1_"  [formControl]="measurementNameControl" required ngDefaultControl >

                <select  *ngIf="isLoading ==false && existingPoint == null" class="select" [(ngModel)]="SelectedWSREMeasrementPointTypeID"  ngDefaultControl (ngModelChange)="onChangeWSREMeasurementPoint($event)">
                    <option value=0 disabled selected>{{"Select a Name" | translate | async}}</option>
                    <option *ngFor="let tool of WSREMeasurmentPoints" [value]="tool.Id">{{tool.Name}}</option>
                </select>
                
            </div>

            <div *ngIf="measurementNameControl.errors && (measurementNameControl.dirty || measurementNameControl.touched)" style="margin-bottom: 20px;">
                <mat-error *ngIf="measurementNameControl.errors.required">{{'New Measurement Point Name is required' | translate | async}}</mat-error>
            </div>
            <div class="input-container">
                <span class="input-desc-label">{{"Default Number Of Measurements" | translate | async}}</span>
                <input [(ngModel)]="defaultNumber" type="number" min="1" placeholder="1">
            </div>



            <div class="input-container">
                <span class="input-desc-label">{{"Default Tool" | translate | async}}</span>
                <select class="select" [(ngModel)]="selectDefaultToolId" required ngDefaultControl (ngModelChange)="onChange($event)">
                    <option value=0 disabled selected>{{'Select a Default Tool' | translate | async}}</option>
                    <option *ngFor="let tool of toolList" [value]="tool.ToolId">{{tool.ToolName}}</option>
                </select>
            </div>
            <div *ngIf="selectError" style="margin-bottom: 20px;">
                <mat-error *ngIf="selectError">{{'Please Select a default tool' | translate | async}}</mat-error>
            </div>

            <div class="input-container">
                <span class="input-desc-label">{{"Disabled" | translate | async}}</span>
                <select class="select" [(ngModel)]="disabled">
                    <option [ngValue]="true">{{'True' | translate | async}}</option>
                    <option [ngValue]="false" selected>{{'False' | translate | async}}</option>
                </select>
            </div>

            <div *ngIf="TypeID==2">
                <!-- <div class="input-container">
                    <span class="input-desc-label">0% Worn Spec</span>
                    <input  [(ngModel)]="worn_0_prec" type="number">
                </div>

                <div class="input-container">
                    <span class="input-desc-label">100% Worn Spec</span>
                    <input  [(ngModel)]="worn_100_prec_Dim" type="number">
                </div> -->
                <div *ngIf="isNumericTool">
                    <div class="input-container">
                        <span class="input-desc-label">0% {{'Worn Spec' | translate | async}}</span>
                        <input [(ngModel)]="worn_0_prec" (ngModelChange)="onZeroWornChange($event)" [disabled]="worn_100_prec_Dim" type="number" step="0.001" min="0">
                    </div>

                    <div class="input-container">
                        <span class="input-desc-label">100% {{'Worn Spec' | translate | async}}</span>
                        <input [(ngModel)]="worn_100_prec_Dim" (ngModelChange)="onHundredWornChange($event)" [disabled]="worn_0_prec" type="number" step="0.001" min="0">
                    </div>

                    <div class="input-container">
                        <span class="input-desc-label">{{'Tolerance' | translate | async}} +/-</span>
                        <input *ngIf="toleranceType !== 'Max'" [(ngModel)]="Tolerance" type="number" step="0.001" min="0">
                        <input *ngIf="toleranceType === 'Max'" value="Max" type="text" readonly>
                    </div>

                    <div class="input-container">
                        <mat-radio-group [(ngModel)]="toleranceType" class="tolerance-radio-group" (change)="onToleranceTypeChange()">
                            <mat-radio-button value="Both">{{'Both' | translate | async}}</mat-radio-button>
                            <mat-radio-button value="Plus">{{'Plus' | translate | async}}</mat-radio-button>
                            <mat-radio-button value="Minus">{{'Minus' | translate | async}}</mat-radio-button>
                            <mat-radio-button value="Max">{{'Max' | translate | async}}</mat-radio-button>                                   
                        </mat-radio-group>
                    </div>
                </div>   

                <div class="input-container" *ngIf="isNumericTool == false" >
                    <span class="input-desc-label">{{'Inspection Type' | translate | async}}</span>
                    <input [(ngModel)]="inspectionType" type="text" maxlength="50">
                    <div class="error-message" *ngIf="inspectionType && inspectionType.length > 50">
                        {{'Inspection Type cannot exceed 50 characters.' | translate | async}}
                    </div>
                </div>

                <div class="input-container" *ngIf="dealerGroupId>0">
                    <span class="input-desc-label">{{'Standard Cost Repair' | translate | async}}</span>
                    <input [(ngModel)]="standardCostRepair" type="number">
                </div>

                <div class="input-container" *ngIf="dealerGroupId>0">
                    <span class="input-desc-label">{{'Standard Hours Repair' | translate | async}}</span>
                    <input   [(ngModel)]="standardHoursRepair" type="number">
                </div>
            </div>


            <div class="margin-bottom-24">
                <div class="input-desc-label">{{'You can attach a photo of this measurement point ' | translate | async}}</div>
                <input type='file' (change)="onSelectMPPhoto($event)">
                <div style="margin-top: 8px;">
                    <img *ngIf="imageUrl" [src]="imageUrl" height="100">
                    <!-- <img *ngIf="existingPoint != null" class="measurement-image" src="/Api/Application/getMeasurementPointsThumbnail/?measurementPonitsId={{SelectedWSREMeasrementPointID}}"  /> -->
                </div>
            </div>
        </div>
        <div class="ttmodal__footer">
            <button mat-raised-button (click)="onNoClick()">{{"Cancel" | translate | async}}</button>
            <button *ngIf="existingPoint == null" mat-raised-button color="warn" [class.loading]="saving" (click)="createNewMP()">
                <span class="material-icons button__icon">check</span>
                <span class="button__text">{{'Create' | translate | async}}</span>
            </button>
            <button *ngIf="existingPoint != null" mat-raised-button color="warn" [class.loading]="saving" (click)="UpdateMp()">
                <span class="material-icons button__icon">check</span>
                <span class="button__text">{{'Update' | translate | async}}</span>
            </button>
        </div>
    </div>